module.exports = __webpack_public_path__ + "media/integrations/shopify-bed14c21.svg";